export const selectSearchGuestStep = (state: RootState) =>
  state.searchGuest.step

export const selectSearchGuestPhone = (state: RootState) =>
  state.searchGuest.phone

export const selectSearchGuestValue = (state: RootState) =>
  state.searchGuest.search
